import { useEffect, useState } from "react";
import { Stack, Tabs, Tab } from "@mui/material";
import AppLoader from "../../../components/AppLoader";
import RichTextEditor from "../../../components/TextEditor";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import {
  getAdminSetting,
  updateAdminSetting,
} from "../../../services/adminSettingApiFn";
import { handleOpenSnackBar } from "../../../utils";
import { useTranslation } from "react-i18next";

const DeliveryInformationPage = () => {
  const { t } = useTranslation(["setting", "common"]);
  const [isLoading, setIsLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [textEn, setTextEn] = useState("");
  const [textRo, setTextRo] = useState("");
  const [setting, setSetting] = useState(null);

  const decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };

  useEffect(() => {
    fetchAdminSetting();
  }, []);

  const fetchAdminSetting = async () => {
    try {
      setIsLoading(true);
      const response = await getAdminSetting();
      if (response.data.status === "success") {
        const data = response.data.data;
        setSetting(data);
        setTextEn(decodeHtml(data.deliveryInformation?.en || ""));
        setTextRo(decodeHtml(data.deliveryInformation?.ro || ""));
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSetting = async () => {
    try {
      const payload = {
        deliveryInformation: {
          en: textEn,
          ro: textRo,
        },
      };

      setIsLoading(true);
      const response = await updateAdminSetting(setting?._id, payload);
      if (response.data.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        fetchAdminSetting();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditorChange = (language, html) => {
    if (language === "en") {
      setTextEn(html);
    } else {
      setTextRo(html);
    }
  };

  const handleTabChange = (_, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <PaperContainer
        title={t("deliveryInformation")}
        subtitle={t("viewEditDeliveryInformation")}
      >
        <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
          <Tab label={t("english")} />
          <Tab label={t("romanian")} />
        </Tabs>

        {tabIndex === 0 && (
          <RichTextEditor
            value={textEn}
            onChange={(html) => handleEditorChange("en", html)}
          />
        )}
        {tabIndex === 1 && (
          <RichTextEditor
            value={textRo}
            onChange={(html) => handleEditorChange("ro", html)}
          />
        )}

        <Stack alignItems="flex-end">
          <GlobalButton
            btnText="update"
            handleClickBtn={updateSetting}
            styleProps={{ mt: 3, height: 40, width: 100 }}
          />
        </Stack>
      </PaperContainer>
    </>
  );
};

export default DeliveryInformationPage;
